<template>
  <div class="RecordActions">
    <div>
      <slot />
      <Btn
        v-if="doShowDelete"
        class="ib sm inv noBorder danger"
        :class="{ 'noBorder': !hasBorders }"
        data-cy="delete"
        :isLoading="isDeleting"
        @click="PROMPT_DELETE({
          confirm: remove,
          name,
        })">
        {{ $t('remove') }}
      </Btn>
      <Route
        v-if="doShowEdit"
        :id="record.id"
        class="Btn ib sm info inv"
        :class="{ noBorder: !hasBorders }"
        data-cy="edit"
        :to="recordRouteName">
        {{ $t('details') }}
      </Route>
      <slot name="after" />
    </div>
    <slot name="tail" />
  </div>
</template>

<script>
import { actions } from '@utils'
import { capitalizeFirst } from '@utils//filters'
import { toActionName } from '@store/utils'

export default {
  props: {
    doShowDelete: { type: Boolean, default: true },
    doShowEdit: { type: Boolean, default: true },
    hasBorders: Boolean,
    name: String,
    record: Object,
    routeName: String,
  },
  data() {
    return {
      isDeleting: false,
    }
  },
  computed: {
    actionName() {
      return toActionName(this.name)
    },
    recordRouteName() {
      return this.routeName || capitalizeFirst(this.name)
    },
  },
  methods: {
    remove() {
      return this.$wrap(
        this.$store.dispatch(`DELETE_${this.actionName}`, this.record),
        'isDeleting',
        this.$t('success'),
      )
    },
    ...actions('PROMPT_DELETE'),
  },
}
</script>

<style lang="scss">
.RecordActions {
  display: flex;
  justify-content: space-between;

  .Field-cont {
    margin: 0;
  }
}
</style>

<i18n>
{
  "en": {
    "details": "Edit",
    "remove": "Delete",
    "success": "Successfully deleted"
  }
}
</i18n>
